export enum Enum_LevageStatus {
    PREPARATION = 1,
    EN_COURS = 2,
    TERMINE = 3,
    TERMINE_NON_REALISE = 4,
    PREPARATION_EN_COURS_DE_VALIDATION = 5,
    PREPARATION_INVALIDE = 6,
    PREPARATION_A_RECOMMENCER = 7,
    ELABORATION_A_CORRIGER = 8,
    ELABORATION_A_EXECUTER = 9,
    NON_TERMINE = 10,
    NON_TERMINE_CLOTURE = 11,
    ELABORATION_COMPLEXE = 12,
}

    // const ELABORATION_EN_COURS       = 1;//1
    // const ELABORATION_A_VALIDER     = 5;//2
    // const ELABORATION_CLOTURE       = 6;//3a
    // const ELABORATION_A_CORRIGER    = 8;//3b
    // const ELABORATION_A_EXECUTER    = 9;//3c
    // const ELABORATION_RECOMMENCER   = 7;

    // const EN_COURS                  = 2;//4
    // const NON_TERMINE               = 10;//5
    // const NON_TERMINE_CLOTURE       = 11;//6a
    // const TERMINE                   = 3;//6d
    // const TERMINE_NON_REALISE       = 4;//6b
    // const ELABORATION_COMPLEXE      = 12;//6c